import { render, staticRenderFns } from "./GertrudeForm.vue?vue&type=template&id=03247b1d&scoped=true&"
import script from "./GertrudeForm.vue?vue&type=script&lang=js&"
export * from "./GertrudeForm.vue?vue&type=script&lang=js&"
import style0 from "./GertrudeForm.vue?vue&type=style&index=0&id=03247b1d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03247b1d",
  null
  
)

export default component.exports